const version = process.env.APP_VERSION;
export default version;
